import * as React from "react";
import type { SVGProps } from "react";
const ItServices = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_1126)">
      <path
        fill="currentColor"
        d="M2 10.6667v8C2 19.4042 2.5958 20 3.3333 20H6v-4.6667c0-.3666.3-.6666.6667-.6666s.6666.3.6666.6666V20H10v-4.6667c0-.3666.3-.6666.6667-.6666s.6666.3.6666.6666V20H14v-4.6667c0-.3666.3-.6666.6667-.6666s.6666.3.6666.6666V20H18v-4.6667c0-.3666.3-.6666.6667-.6666s.6666.3.6666.6666V20H22a1.332 1.332 0 0 0 1.3333-1.3333v-8A1.332 1.332 0 0 0 22 9.3333h-1.3333V8a1.332 1.332 0 0 0-1.3334-1.3333H18V5.3333A1.332 1.332 0 0 0 16.6667 4h-8a1.332 1.332 0 0 0-1.3334 1.3333v1.3334H6A1.332 1.332 0 0 0 4.6667 8v1.3333H3.3333A1.332 1.332 0 0 0 2 10.6667"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_1126">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default ItServices;
